"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var emoji_exports = {};
__export(emoji_exports, {
  EmojiNode: () => EmojiNode
});
module.exports = __toCommonJS(emoji_exports);
var import_core = require("@tiptap/core");
const EmojiNode = import_core.Node.create({
  name: "emoji",
  group: "inline",
  inline: true,
  atom: true,
  selectable: false,
  addAttributes() {
    return {
      emoji: {
        default: ""
      },
      kind: {
        default: "unicode"
      },
      image: {
        default: null
      }
    };
  },
  addCommands() {
    return {
      insertEmoji: /* @__PURE__ */ __name((emoji, kind, image) => ({ commands }) => {
        if (kind === "image") emoji = `:${emoji}:`;
        return commands.insertContent({
          type: this.name,
          attrs: { emoji, kind, image }
        });
      }, "insertEmoji")
    };
  },
  parseHTML() {
    return [
      {
        tag: `span[data-type="${this.name}"]`
      }
    ];
  },
  addNodeView() {
    return ({ node, HTMLAttributes }) => {
      const container = document.createElement("span");
      const containerAttributes = (0, import_core.mergeAttributes)(
        {
          "data-type": this.name,
          class: "emoji"
        },
        HTMLAttributes
      );
      for (const [k, v] of Object.entries(containerAttributes)) {
        if (v !== null) {
          container.setAttribute(k, v);
        }
      }
      if (node.attrs.kind === "image") {
        const imgElement = document.createElement("img");
        imgElement.alt = node.attrs.emoji;
        imgElement.setAttribute("data-type", this.name);
        void this.options.getBlobRef(node.attrs.image).then((val) => {
          imgElement.src = val.src;
          imgElement.srcset = val.srcset;
        });
        container.append(imgElement);
      } else {
        container.append(node.attrs.emoji);
      }
      return {
        dom: container
      };
    };
  },
  renderHTML({ node, HTMLAttributes }) {
    if (node.attrs.kind === "image") {
      return [
        "span",
        (0, import_core.mergeAttributes)(
          {
            "data-type": this.name,
            class: "emoji"
          },
          HTMLAttributes
        ),
        [
          "img",
          (0, import_core.mergeAttributes)({
            "data-type": this.name,
            src: node.attrs.image,
            alt: node.attrs.emoji
          })
        ]
      ];
    }
    return [
      "span",
      (0, import_core.mergeAttributes)(
        {
          "data-type": this.name,
          class: "emoji"
        },
        HTMLAttributes
      ),
      node.attrs.emoji
    ];
  }
});
//# sourceMappingURL=emoji.js.map
